import React from 'react';

import styles from './MainSection.module.css';

const MainSection = props => {
  return <div className={`${styles.container}`}>{props.children}</div>;
};

export default MainSection;
